import _ from 'lodash';
import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Strip out unnecessary validations data inside dynamic binding paths
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const isDynBound = DomTypeUtils.isDynBound(data);

  const _onValidations = (fieldsArray: Array<Record<any, any>>, fn: any) => {
    _.each(fieldsArray, (fieldJson) => {
      if (fieldJson.hasOwnProperty && fieldJson.hasOwnProperty('validations')) {
        fn(fieldJson);
      }
    });
  };

  const _iterateBindingPaths = (
    nodeData: Record<string, any>,
    fn: (() => void) | ((fieldJson?: any) => void)
  ) => {
    _.forOwn(nodeData.dyn.bind, (value, key) => {
      if (key === 'style') {
        _.forOwn(value, (styleValue) => {
          _onValidations(styleValue, fn);
        });
      } else {
        _onValidations(value, fn);
      }
    });
  };

  let needed = false;
  if (isDynBound) {
    _iterateBindingPaths(data, () => {
      needed = true;
    });
  }

  return {
    needed,
    logData: {
      msg: 'Unnecessary validations in DynBinding paths',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      _iterateBindingPaths(data, (fieldJson) => {
        // eslint-disable-next-line webflow/no-delete
        delete fieldJson.validations;
      });
    },
  };
};
